export default [
  {
    path: '/security',
    component: () => import('@/layouts/SecurityLayout.vue'),
    children: [
      {
        path: 'unauthorized',
        name: 'SecurityUnauthorized',
        component: () => import('@/views/security/unauthorized.vue'),
        meta: { pageTitle: 'Unauthorized', doesNotRequireAuthentication: true },
      },
      {
        path: 'register-device',
        name: 'SecurityRegisterDevice',
        component: () =>
          import('@/views/security/register/RegisterDeviceFlow.vue'),
        meta: {
          pageTitle: 'Register Authenticator',
          doesNotRequireAuthentication: true,
        },
      },
      {
        path: 'verify',
        name: 'SecurityVerification',
        component: () => import('@/views/security/verification.vue'),
        meta: {
          pageTitle: 'Security Verification',
          doesNotRequireAuthentication: true,
        },
      },
    ],
  },
];
